// extracted by mini-css-extract-plugin
export default {"icon":"StatusIconWithText_icon--V2e"};